import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11e88743"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "!fixed top-0 right-0 bottom-0 left-0 z-40 bg-black bg-opacity-20"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "17px",
  height: "17px",
  viewBox: "0 0 17 17",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "ic_close"),
  /*#__PURE__*/_createElementVNode("g", {
    id: "dashboard",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "close",
      transform: "translate(-1233.000000, -106.000000)",
      stroke: "#161121",
      "stroke-width": "1.5"
    }, [
      /*#__PURE__*/_createElementVNode("g", {
        id: "Group-28",
        transform: "translate(160.000000, 59.000000)"
      }, [
        /*#__PURE__*/_createElementVNode("g", {
          id: "ic_close",
          transform: "translate(1074.000000, 48.000000)"
        }, [
          /*#__PURE__*/_createElementVNode("line", {
            id: "Path",
            x1: "0",
            y1: "15",
            x2: "15",
            y2: "0"
          }),
          /*#__PURE__*/_createElementVNode("line", {
            id: "Path",
            x1: "15",
            y1: "15",
            x2: "0",
            y2: "0"
          })
        ])
      ])
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "toggle", _normalizeProps(_guardReactiveProps(_ctx.state)), undefined, true),
    _createVNode(_Transition, {
      name: "fade",
      appear: ""
    }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "pop",
      appear: ""
    }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "!fixed right-0 bottom-0 left-0 top-0 z-50 flex px-2",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }, [
              _createElementVNode("div", {
                role: "dialog",
                class: _normalizeClass(["relative m-auto bg-white rounded-lg shadow-lg z-50", [_ctx.padding, _ctx.size]]),
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, [
                (_ctx.closeButton)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "absolute right-4 top-4",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                    }, _hoisted_3))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "body", _normalizeProps(_guardReactiveProps(_ctx.state)), undefined, true)
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}